module.exports = "/images/TXR Preview_pages-5.jpg?79f7b38973735f34a0d9eb7f6bc14fe7";